import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "" }
const _hoisted_5 = {
  key: 0,
  class: "w100"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("section", {
  class: "kakugo w100",
  style: {"top":"0","z-index":"10"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ofh w80 fl",
    style: {"margin-top":"25px"}
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "fs20 ls1 fl",
      style: {"margin-left":"80px","margin-top":"24px"}
    }, [
      /*#__PURE__*/_createElementVNode("span", null, "カレンダー共有")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "clear" })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = { class: "w100 pad15" }
const _hoisted_10 = {
  class: "w100 mt20",
  style: {}
}
const _hoisted_11 = { class: "fl w30 pad10" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "カレンダー共有設定", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, [
  /*#__PURE__*/_createTextVNode(" waaq Linkで登録している同一グループのメンバーにカレンダーを共有します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" カレンダーを共有した場合でも、waaq Link経由で作成したイベントのみ削除できます。 ")
], -1)
const _hoisted_15 = [
  _hoisted_13,
  _hoisted_14
]
const _hoisted_16 = { key: 1 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "会議室の共有設定", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", { class: "mt20" }, [
  /*#__PURE__*/_createTextVNode(" Microsoftの会議室等のリソースのアカウントを接続します。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 接続すると、MSリソースの予定を調整カレンダーに表示できるようになります。"),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_21 = {
  key: 0,
  class: "fl w60"
}
const _hoisted_22 = { class: "mb20" }
const _hoisted_23 = {
  class: "centered",
  style: {"width":"120px"}
}
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "同一グループの共有しているお相手", -1)
const _hoisted_29 = {
  class: "centered",
  style: {"width":"120px"}
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "共有を受けているカレンダー", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "fl" }
const _hoisted_39 = {
  class: "fl",
  style: {"margin-left":"30px","margin-top":"-5px"}
}
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "fs9" }, "閲覧権限", -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { class: "fl" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_44 = { key: 1 }
const _hoisted_45 = {
  class: "w100 mt20 centered",
  style: {}
}
const _hoisted_46 = /*#__PURE__*/_createElementVNode("div", null, " カレンダーを連携することで、waaq Link内でのみカレンダーを共有することができます。 ", -1)
const _hoisted_47 = { class: "w100 centered mt40" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_49 = { key: 2 }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "カレンダーを共有している相手が見つかりませんでした。", -1)
const _hoisted_54 = ["src"]
const _hoisted_55 = { key: 2 }
const _hoisted_56 = {
  class: "fw400",
  style: {"margin-top":"10px"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", {
  width: "80",
  class: "indent2"
}, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("th", {
  width: "260",
  class: "fs12",
  style: {"padding":"5px 10px"}
}, [
  /*#__PURE__*/_createTextVNode(" 氏名"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メールアドレス ")
], -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", { width: "140" }, "閲覧権限", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("th", { width: "160" }, null, -1)
const _hoisted_61 = { class: "" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_63 = { class: "fs12" }
const _hoisted_64 = ["src", "onClick"]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_67 = { key: 0 }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = {
  class: "centered",
  style: {"margin-top":"100px"}
}
const _hoisted_70 = /*#__PURE__*/_createElementVNode("p", { class: "grey" }, "カレンダーを共有を受けていません。", -1)
const _hoisted_71 = ["src"]
const _hoisted_72 = {
  key: 2,
  class: "fw400 mt10",
  style: {}
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("th", {
  width: "80",
  class: ""
}, null, -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", {
  width: "340",
  class: "fs12",
  style: {"padding":"5px 10px"}
}, [
  /*#__PURE__*/_createTextVNode(" カレンダー名"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("メールアドレス（カレンダーID） ")
], -1)
const _hoisted_75 = { class: "" }
const _hoisted_76 = {
  class: "pad10",
  style: {"min-width":"320px"}
}
const _hoisted_77 = { class: "fs13" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_79 = { class: "fs11" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_81 = {
  key: 1,
  class: "fl w60 mt20"
}
const _hoisted_82 = {
  key: 0,
  style: {}
}
const _hoisted_83 = {
  class: "fl",
  style: {"width":"400px"}
}
const _hoisted_84 = { key: 0 }
const _hoisted_85 = {
  href: "/sign_in/ms_resources",
  class: "AuthButton mt40"
}
const _hoisted_86 = ["src"]
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_88 = { key: 1 }
const _hoisted_89 = {
  class: "w100 mt20 centered",
  style: {}
}
const _hoisted_90 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_93 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_OAuthButtons = _resolveComponent("OAuthButtons")!
  const _component_ListLoader = _resolveComponent("ListLoader")!
  const _component_SharedMsResourcesModal = _resolveComponent("SharedMsResourcesModal")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", _hoisted_4, [
              (!_ctx.isSP)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                : _createCommentVNode("", true),
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    (_ctx.viewType == 'my_calendar')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_15))
                      : (_ctx.viewType == 'resources')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                        : _createCommentVNode("", true),
                    _hoisted_20,
                    (_ctx.viewType == 'my_calendar')
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeViewType(`resources`)))
                        }, " 会議室の共有設定に切り替え "))
                      : (_ctx.viewType == 'resources')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 3,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeViewType(`my_calendar`)))
                          }, " カレンダー共有設定に切り替え "))
                        : _createCommentVNode("", true)
                  ]),
                  (_ctx.viewType == 'my_calendar')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", {
                            class: _normalizeClass(`roomsCategoryTab pointer centered centering fl fs12 w50 ${
                                            _ctx.selectedCategory == 'list' ? 'selected fw600' : ''
                                        }`),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectCategory(`list`)))
                          }, [
                            _createElementVNode("div", _hoisted_23, [
                              _createVNode(_component_UserIcon, {
                                member: _ctx.rm.userInfo,
                                width: 38,
                                canEdit: false,
                                updateSelf: false,
                                showTooltip: false,
                                class: "fl mr3"
                              }, null, 8, ["member"]),
                              _createElementVNode("img", {
                                class: "mt10 fl",
                                width: "20",
                                height: "22",
                                src: _ctx.$getAssetImageUrl(`/assets/icons/status_play.png`)
                              }, null, 8, _hoisted_24),
                              _createElementVNode("img", {
                                class: "fl",
                                width: "45",
                                height: "45",
                                src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                                style: {"margin-top":"-3px"}
                              }, null, 8, _hoisted_25),
                              _hoisted_26
                            ]),
                            _hoisted_27,
                            _hoisted_28
                          ], 2),
                          _createElementVNode("div", {
                            class: _normalizeClass(`roomsCategoryTab pointer centered centering fl fs12 w50 ${
                                            _ctx.selectedCategory == 'share_me_list' ? 'selected fw600' : ''
                                        }`),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectCategory(`share_me_list`)))
                          }, [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_UserIcon, {
                                member: _ctx.rm.userInfo,
                                width: 38,
                                canEdit: false,
                                updateSelf: false,
                                showTooltip: false,
                                class: "fl mr3"
                              }, null, 8, ["member"]),
                              _createElementVNode("img", {
                                class: "mt10 fl",
                                width: "20",
                                height: "22",
                                src: _ctx.$getAssetImageUrl(`/assets/icons/status_play.png`),
                                style: {"transform":"scale(-1, 1)"}
                              }, null, 8, _hoisted_30),
                              _createElementVNode("img", {
                                class: "fl",
                                width: "45",
                                height: "45",
                                src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                                style: {"margin-top":"-2px"}
                              }, null, 8, _hoisted_31),
                              _hoisted_32
                            ]),
                            _hoisted_33,
                            _hoisted_34
                          ], 2),
                          _hoisted_35
                        ]),
                        _hoisted_36,
                        (_ctx.selectedCategory == `list`)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (_ctx.rm.didConnectCal)
                                ? (_openBlock(), _createElementBlock("form", {
                                    key: 0,
                                    id: "form",
                                    onSubmit: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
                                  }, [
                                    _createElementVNode("div", _hoisted_38, [
                                      _createVNode(_component_MdTextfieldTag, {
                                        name: "メールアドレス",
                                        style: {"height":"56px","min-width":"280px"},
                                        class: "fl fs14",
                                        value: _ctx.shareUser.email,
                                        onInputValue: _ctx.inputEmail,
                                        onBlur: _ctx.checkEmailField,
                                        errMessage: _ctx.failedMail ? `不正なメールアドレスです` : null,
                                        required: ""
                                      }, null, 8, ["value", "onInputValue", "onBlur", "errMessage"])
                                    ]),
                                    _createElementVNode("div", _hoisted_39, [
                                      _hoisted_40,
                                      _hoisted_41,
                                      _createVNode(_component_SelectTag, {
                                        name: "meeting_time",
                                        id: "select_meeting_time",
                                        class: "fl fs14 roundForm",
                                        style: {"min-width":"130px","height":"50px"},
                                        options: _ctx.SelectUtil.calendarShareTypes.map(e => e.name),
                                        defaultOption: `${_ctx.findShareTypeDicByType(this.shareUser.share_type).name}`,
                                        onSelectValue: _ctx.selectNewShareType
                                      }, null, 8, ["options", "defaultOption", "onSelectValue"])
                                    ]),
                                    _createElementVNode("div", _hoisted_42, [
                                      _createElementVNode("button", {
                                        type: "submit",
                                        class: "pointer centered circle_button skyblueBg fs16 rad8 mt15 ml20",
                                        style: {"width":"100px","height":"50px","padding":"14px 8px"},
                                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.shareMyCalendar && _ctx.shareMyCalendar(...args)))
                                      }, " 共有 ")
                                    ]),
                                    _hoisted_43
                                  ], 32))
                                : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                    _createElementVNode("div", _hoisted_45, [
                                      _hoisted_46,
                                      _createElementVNode("div", _hoisted_47, [
                                        _createVNode(_component_OAuthButtons, { showSSO: false })
                                      ])
                                    ])
                                  ])),
                              _hoisted_48,
                              (_ctx.rm.didConnectCal)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    (!_ctx.users)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                          _createVNode(_component_ListLoader)
                                        ]))
                                      : (_ctx.users.length == 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            _createElementVNode("div", _hoisted_52, [
                                              _hoisted_53,
                                              _createElementVNode("img", {
                                                src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                                width: "40",
                                                height: "40"
                                              }, null, 8, _hoisted_54)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                            _createElementVNode("table", _hoisted_56, [
                                              _hoisted_57,
                                              _hoisted_58,
                                              _hoisted_59,
                                              _hoisted_60,
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: `${index}${_ctx.updatedAt}`,
                                                  class: "borderGrey",
                                                  style: {"height":"60px"}
                                                }, [
                                                  _createElementVNode("td", _hoisted_61, [
                                                    _createVNode(_component_UserIcon, {
                                                      member: user,
                                                      width: 38,
                                                      canEdit: false,
                                                      updateSelf: false,
                                                      showTooltip: false,
                                                      class: "fl mr3 ml20"
                                                    }, null, 8, ["member"])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("span", null, _toDisplayString(user.name), 1),
                                                    _hoisted_62,
                                                    _createElementVNode("span", _hoisted_63, _toDisplayString(user.email), 1)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createVNode(_component_SelectTag, {
                                                      name: "select_share_type",
                                                      id: `select_share_type${index}`,
                                                      class: "fl fs13 roundForm",
                                                      style: {"min-width":"130px","height":"50px","border":"0"},
                                                      options: _ctx.SelectUtil.calendarShareTypes.map(e => e.name),
                                                      defaultOption: `${_ctx.findShareTypeDicByType(user.share_type).name}`,
                                                      onSelectValue: ($event: any) => (_ctx.selectShareType(user, index))
                                                    }, null, 8, ["id", "options", "defaultOption", "onSelectValue"])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _withDirectives(_createElementVNode("img", {
                                                      src: _ctx.$getAssetImageUrl(`/assets/icons/trash.png`),
                                                      width: "16",
                                                      height: "19",
                                                      class: "pointer fr",
                                                      style: {"margin-right":"40px"},
                                                      onClick: ($event: any) => (_ctx.deleteSharedUser(user))
                                                    }, null, 8, _hoisted_64), [
                                                      [
                                                        _directive_tooltip,
                                                        `共有を解除`,
                                                        void 0,
                                                        { top: true }
                                                      ]
                                                    ])
                                                  ])
                                                ]))
                                              }), 128))
                                            ])
                                          ]))
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                              _hoisted_66,
                              (!_ctx.sharedCtags)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                    _createVNode(_component_ListLoader)
                                  ]))
                                : (_ctx.sharedCtags.length == 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                      _createElementVNode("div", _hoisted_69, [
                                        _hoisted_70,
                                        _createElementVNode("img", {
                                          src: _ctx.$getAssetImageUrl(`/assets/icons/no_rooms.png`),
                                          width: "40",
                                          height: "40"
                                        }, null, 8, _hoisted_71)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_72, [
                                      _hoisted_73,
                                      _hoisted_74,
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sharedCtags, (ctag, index) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: `${index}${_ctx.updatedAt}`,
                                          class: "borderGrey",
                                          style: {"height":"60px"}
                                        }, [
                                          _createElementVNode("td", _hoisted_75, [
                                            _createVNode(_component_UserIcon, {
                                              member: ctag,
                                              width: 38,
                                              canEdit: false,
                                              updateSelf: false,
                                              showTooltip: false,
                                              class: "fl mr3 ml15"
                                            }, null, 8, ["member"])
                                          ]),
                                          _createElementVNode("td", _hoisted_76, [
                                            _createElementVNode("span", _hoisted_77, _toDisplayString(ctag.name), 1),
                                            _hoisted_78,
                                            _createElementVNode("span", _hoisted_79, _toDisplayString(ctag.email), 1)
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                            ])),
                        _hoisted_80
                      ]))
                    : (_ctx.viewType == 'resources')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                          (_ctx.ug)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                _createElementVNode("div", _hoisted_83, [
                                  (!_ctx.ug.user_group_setting.can_connect_ms_resources)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                        _createElementVNode("a", _hoisted_85, [
                                          _createElementVNode("img", {
                                            src: _ctx.$getAssetImageUrl(`/assets/buttons/microsoft_bnr.png`),
                                            width: "260",
                                            height: "58"
                                          }, null, 8, _hoisted_86)
                                        ]),
                                        _hoisted_87
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_88, [
                                        _createElementVNode("div", _hoisted_89, [
                                          _createElementVNode("button", {
                                            type: "submit",
                                            class: "fl pointer centered circle_button skyblueBg fs14 rad8 mt15 mr20",
                                            style: {"height":"50px"},
                                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.clickSelectMsResources && _ctx.clickSelectMsResources(...args)))
                                          }, " 共有する会議室を読み込み "),
                                          _createElementVNode("button", {
                                            type: "submit",
                                            class: "fl pointer centered circle_button with_white_bg fs14 rad8 mt15 alertRed noborder underline mr20",
                                            style: {"height":"50px"},
                                            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.clickDisconnectMsResources && _ctx.clickDisconnectMsResources(...args)))
                                          }, " 連携を解除 "),
                                          _hoisted_90
                                        ]),
                                        _hoisted_91
                                      ]))
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_92
                        ]))
                      : _createCommentVNode("", true)
                ]),
                _hoisted_93
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_94
    ]),
    _createVNode(_component_SharedMsResourcesModal)
  ]))
}